import { useAppContext } from "../../context/AppContext";
import { ButtonsTrans } from "../../utils/translations";
import ActionToggleButton from "./ActionToggleButton";

const containerStyles = {
  pill: {
    active: "bg-brown border-brown text-white shadow-sm",
    inactive:
      "bg-pink-100 border-pink-200 text-brown hover:bg-brown/90 hover:border-brown/90 hover:text-white",
  },
  soft: {
    active: "bg-brown/90 border-brown/80 text-white",
    inactive:
      "bg-brown/10 border-brown/15 text-brown hover:bg-brown/85 hover:border-brown/85 hover:text-white",
  },
  outline: {
    active: "bg-brown border-brown text-white",
    inactive:
      "bg-white border-brown/40 text-brown hover:bg-brown hover:border-brown hover:text-white",
  },
  elevated: {
    active: "bg-brown border-brown text-white shadow-md",
    inactive:
      "bg-pink-50 border-pink-100 text-brown shadow-sm hover:bg-brown/90 hover:border-brown/90 hover:text-white hover:shadow-md",
  },
};

export default function SaveForLaterButton({ isSaved, toggleSave, variant = "elevated" }) {
  const { language } = useAppContext();

  return (
    <ActionToggleButton
      isActive={isSaved}
      onClick={toggleSave}
      activeLabel={ButtonsTrans[language].saved}
      inactiveLabel={ButtonsTrans[language].saveForLater}
      activeIcon={(
        <svg
          className="mr-2 h-5 w-5 text-white"
          fill="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M5.75 3A2.75 2.75 0 003 5.75v14.19c0 .94 1.07 1.48 1.82.92L12 16.2l7.18 4.66c.75.49 1.82-.04 1.82-.92V5.75A2.75 2.75 0 0018.25 3H5.75z" />
        </svg>
      )}
      inactiveIcon={(
        <svg
          className="mr-2 h-5 w-5 text-brown"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17.25 3.75H6.75A2.25 2.25 0 004.5 6v13.125c0 .663.747 1.057 1.298.684L12 15.375l6.202 4.434c.551.373 1.298-.021 1.298-.684V6a2.25 2.25 0 00-2.25-2.25z"
          />
        </svg>
      )}
      variant={variant}
      stylesByVariant={containerStyles}
      focusRingClass="focus-visible:ring-brown/40"
    />
  );
}
